export default __webpack_public_path__ + "static/media/glaciers_of_ice_bb_1.bb9f132a.mp4";